import Vue from 'vue'
import Vuex from 'vuex'
import updateInfo from './modules/updateInfo'
import testDrive from './modules/testDrive'
import headChange from './modules/headChange'
import loginchange from './modules/loginchange'
import Index from './modules/Index'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  locInfo: {},
	  department: ''
  },
  mutations: {
	locInfo(state,data) {
		state.locInfo = data
	},
	department(state,data) {
		state.department = data
	}
  },
  modules: {
    updateInfo,
    testDrive,
    headChange,
    loginchange,
    Index
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js